module.exports = __webpack_public_path__ + "img/EOArchitectureTopPictureOffer.50451253.png";